import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { fetchWithCSRF } from '../utils/csrfUtils';

const EditRecipeButton = ({ recipeId }) => {
    const { sessionToken } = useAuth();
    const [isOwner, setIsOwner] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const checkOwnership = async () => {
            try {
                console.log('Checking recipe ownership for recipe id:', recipeId);
                const response = await fetchWithCSRF(`/api/v1/recipe/ownership_check`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionToken}`
                    },
                    body: JSON.stringify({ recipe_id: recipeId })
                });
                const data = await response.json();
                console.log('Recipe ownership check response:', data);
                setIsOwner(data.recipe_owner);
            } catch (error) {
                console.error('Error checking recipe ownership:', error);
            } finally {
                setIsLoading(false);
            }
        };

        if (sessionToken) {
            checkOwnership();
        }
    }, [recipeId, sessionToken]);

    const handleEditRecipe = () => {
        navigate(`/recipes/${recipeId}/edit`);
    };

    if (isLoading) {
        return null;
    }

    return isOwner ? (
        <button 
            onClick={handleEditRecipe}
            style={{ 
                backgroundColor: '#52cd92',
                    borderColor: 'transparent',
                    borderRadius: '4px',
                    fontSize: '1rem',
                    marginBottom: '2rem',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    transition: 'transform 0.2s, background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#45b07c'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#52cd92'}
        >
            Edit Recipe
        </button>
    ) : null;
}

export default EditRecipeButton;